/**
 * @generated SignedSource<<30b7aa234439277d8a3eb9d62f247cbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNovaAgentVersionInput = {
  id: string;
  versionNumber: number;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteNovaAgentVersionMutation$variables = {
  input: DeleteNovaAgentVersionInput;
};
export type DeleteNovaAgentVersionMutation$data = {
  readonly deleteNovaAgentVersion: {
    readonly agent: {
      readonly id: string;
    } | null;
  } | null;
};
export type DeleteNovaAgentVersionMutation = {
  variables: DeleteNovaAgentVersionMutation$variables;
  response: DeleteNovaAgentVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteNovaAgentVersionPayload",
    "kind": "LinkedField",
    "name": "deleteNovaAgentVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNovaAgentVersionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNovaAgentVersionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "49494e6a773eef45d0da338ba87464c0",
    "id": null,
    "metadata": {},
    "name": "DeleteNovaAgentVersionMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNovaAgentVersionMutation(\n  $input: DeleteNovaAgentVersionInput!\n) {\n  deleteNovaAgentVersion(input: $input) {\n    agent {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "212af2ac183ec24498574e2c4b68d438";

export default node;
